export const buildClassPracticeQuery = (classId, classOnly) => {
  const query = new URLSearchParams({
    class_id: String(classId),
    audience_scope: classOnly ? 'class' : 'all',
    limit: '200',
  });
  return query.toString();
};

export const assignmentProgress = (assignment) => {
  const targetSummary = assignment.target_summary || {};
  const completionSummary = assignment.completion_summary || assignment.summary || assignment.completion || {};
  const total = Number(
    completionSummary.target_count
    ?? targetSummary.target_count
    ?? completionSummary.total_count
    ?? completionSummary.total
    ?? assignment.audience_count
    ?? 0,
  );
  const completed = Number(completionSummary.completed_count ?? completionSummary.completed ?? 0);
  return { total, completed };
};

export const classWideAssignment = (assignment) => {
  const audience = assignment?.audience_snapshot || assignment?.audience || {};
  return assignment?.target_summary?.scope === 'class'
    || audience.type === 'class'
    || audience.scope === 'class'
    || assignment?.audience_scope === 'class';
};
